<template>
  <div class="AddQuestionModal">
    <!--    <CorrectPolyPhoneModal-->
    <!--        @refreshInputVal="refreshInputVal"-->
    <!--        :inputValArr="inputValArr"-->
    <!--    ></CorrectPolyPhoneModal>-->
    <el-dialog
        title="编辑题目"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
    >
      <el-form
          ref="form"
          :model="formData"
          :rules="rules"
          size="mini"
          label-width="90px">
        <el-form-item label="题目类型:" prop="questionType">
          <el-radio-group
              v-model="formData.content.type"
              style="margin-left: 30px"
          >
            <el-radio
                v-for="item in questionType"
                :key="item.value"
                :label="item.value">
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="题目标签:">
          <AppTreeSelect
              style="width: 250px"
              :options="options"
              :valueArr="formData.tagIds"
              @tagChange="tagChange"
          ></AppTreeSelect>
        </el-form-item>

        <div
            v-if="
            formData.content.type === 'select' ||
            formData.content.type === 'multipleSelect' ||
            formData.content.type === 'judge'
          "
            class="unShowStar"
        >
          <!--          <el-form-item label="习题题干:">-->
          <!--            <div class="titleContentWrapper">-->
          <!--                          <div class="titleContentWrapperPreview">-->
          <!--                            {{ formData.content.title }}-->
          <!--                          </div>-->
          <!--                        </div>-->
          <!--          </el-form-item>-->
          <AudioText :formData="materialInfo" @onOpenPickTextMaterialModal="onOpenPickTextMaterialModal"></AudioText>
        </div>

        <template
            v-if="formData.content.type === 'select' ||
            formData.content.type === 'multipleSelect'"
        >
          <el-form-item label="选项数量" prop="optionNum">
            <el-select
                style="width: 100%"
                v-model="optionNum"
                placeholder="请选择选项数量"
                @change="handleSelectOptionNum"
            >
              <el-option
                  v-for="item in selectNumOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item
              v-for="(item,index) in selectItemOptions"
              :key="item.value"
              :label="'选项'+ item.label"
          >
            <div class="contentWrapper">
              <el-input v-model="formData.content.item[index]" class="contentWrapperPreview">
              </el-input>
            </div>
          </el-form-item>
        </template>

        <!--单选题-->
        <template v-if="formData.content.type === 'select'">
          <el-form-item
              label="正确选项"
              prop="content.answer[0]"
          >
            <el-select
                style="width: 100%"
                v-model="formData.content.answer[0]"
                placeholder="请选择正确选项"
                @change=""
            >
              <el-option
                  v-for="item in selectItemOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </template>

        <template
            v-if="formData.content.type === 'judge'"
        >
          <el-form-item
              label="正确选项"
              prop="content.answer[0]"
          >
            <el-select
                style="width: 100%"
                v-model="formData.content.answer[0]"
                placeholder="请选择正确选项"
                @change=""
            >
              <el-option
                  v-for="item in judgeTrueOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </template>

        <template
            v-if="
            formData.content.type === 'multipleSelect'
          "
        >
          <el-form-item
              label="正确选项"
              prop="content.answer[0]"
          >
            <el-checkbox-group
                v-model="formData.content.answer"
            >
              <el-checkbox
                  v-for="item in selectItemOptions"
                  :key="item.value"
                  :label="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </template>
      </el-form>
      <div style="text-align: center">
        <el-button type="primary" @click="handleSaveTestQuestion">
          保存
        </el-button>
      </div>
    </el-dialog>
    <MaterialPickModal
        ref="materialPicker"
        materialType="text"
        @onConfirmPickMaterial="onConfirmPickMaterial"
    ></MaterialPickModal>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import CorrectPolyPhoneModal from "@/pages/MyOutLine/CorrectPolyPhoneModal.vue";
import {QUESTION_TYPE, SUBJECT_TYPE} from "@/utils/constants";
import MultiContentComponent from "@/pages/MyOutLine/components/MultiContentComponent.vue";
import ContentPickModal from "@/pages/MyOutLine/components/ContentPickModal.vue";
import AudioText from "@/pages/MyOutLine/components/AudioText.vue";
import MaterialPickModal from "@/pages/MaterialCenter/components/MaterialPickModal.vue";
import AppTreeSelect from "@/components/ui/AppTreeSelect/index.vue";

export default {
  name: "AddQuestionModal",
  props: {
    addType: {
      type: String,
      default: "add",
    },
  },
  components: {
    AppTreeSelect,
    MaterialPickModal,
    AudioText, ContentPickModal, MultiContentComponent, CorrectPolyPhoneModal
  },
  mixins: [],
  data() {
    const questionType = Object.keys(QUESTION_TYPE).map((key) => {
      return {
        value: key,
        label: SUBJECT_TYPE[key],
      };
    });
    return {
      options: [],
      materialInfo: {
        lessonContentTemplate: {
          material: {}
        },
        type: ""
      },
      optionNum: 4,
      selectItemOptions: [],
      formData: this.defaultFormData(),
      rules: {},
      selectNumOptions: [
        {label: "2", value: 2},
        {label: "3", value: 3},
        {label: "4", value: 4},
        {label: "5", value: 5},
        {label: "6", value: 6},
        {label: "7", value: 7},
        {label: "8", value: 8},
        {label: "9", value: 9},
        {label: "10", value: 10},
      ],
      //判断题
      judgeTrueOptions: [
        {
          label: "对",
          value: 0,
        },
        {
          label: "错",
          value: 1,
        },
      ],
      formatTitleItems: ["audioText"],
      inputValArr: [],
      questionType: [...questionType],
      humanOption: [
        {
          label: "老师",
          value: "zhiyuan",
        },
        {
          label: "学生",
          value: "zhigui",
        },
        {
          label: "标准女生",
          value: "sijia",
        },
        {
          label: "沉稳男生",
          value: "stanley",
        },
      ],
      rateArr: [
        {
          label: "慢",
          value: 0.8,
        },
        {
          label: "正常",
          value: 1.0,
        },
        {
          label: "快",
          value: 1.2,
        },
      ],
    };
  },
  watch: {},
  computed: {
    ...mapState("courseCenter", ["tagCategoryList"]),
    visible: {
      get() {
        return this.$store.state.pluginCenter.addQuestionModalVisible;
      },
      set(value) {
        this.$store.commit("pluginCenter/setData", {
          key: "addQuestionModalVisible",
          value,
        });
      },
    },
  },
  async mounted() {
    await this.getTagCategoryList({
      includeChild: true,
      page: 1,
      size: 10000,
    });
    this.options = this.tagCategoryList.data;
    this.handleSelectOptionNum();
  },
  methods: {
    ...mapMutations("courseCenter", ["setData"]),
    ...mapActions("courseCenter", ["getAudioUrl", "getTagCategoryList"]),
    ...mapActions("pluginCenter", ["saveTestQuestion", "getTestQuestionList"]),
    tagChange(val) {
      this.formData.tagIds = val;
    },
    onOpenPickTextMaterialModal() {
      this.$refs.materialPicker.visible = true;
    },
    onConfirmPickMaterial(material) {
      console.log(material)
    },
    async handleSaveTestQuestion() {
      this.formData.content.titleAudio = this.materialInfo.lessonContentTemplate.material
      this.formData.content.title = this.formData.content.titleAudio.displayAudioText;
      this.formData.content.item = this.formData.content.item.slice(0, this.optionNum);

      await this.saveTestQuestion(this.formData)
      await this.getTestQuestionList({})
      this.visible = false;
    },
    initFormData(testPaperId, data) {
      if (data) {
        this.formData = {...data}
        if (!this.formData.tagIds) this.formData.tagIds = [];
        this.formData.content = {...data.content};
        this.formData.content.titleAudio = {...data.content.titleAudio};
        if (!this.formData.content.item) {
          this.formData.content.item = [];
        }
        this.optionNum = this.formData.content.item.length;
        this.handleSelectOptionNum()
        this.materialInfo.lessonContentTemplate.material = this.formData.content.titleAudio;
        this.materialInfo.type = this.formData.content.type;
      } else {
        this.formData = this.defaultFormData();
        this.formData.testPaperId = testPaperId;
        this.materialInfo.lessonContentTemplate.material = this.formData.content.titleAudio
        this.materialInfo.type = null;
      }
    },
    defaultFormData() {
      return {
        content: {
          answer: [
            0
          ],
          item: [],
          itemType: "",
          title: "",
          titleAudio: {
            audioSsmlText: null,
            audioText: null,
            displayAudioText: null,
            duration: 0,
            filename: null,
            id: null,
            markFlag: 0,
            materialId: null,
            materialUrl: null,
            speechRate: 1,
            type: "audio",
            voice: "zhiyuan"
          },
          type: "select"
        },
        id: null,
        testPaperId: null,
        tagIds: [],
      }
    },
    handleSelectOptionNum() {
      let arr = [];
      for (let i = 0; i < this.optionNum; i++) {
        arr.push({label: "ABCDEFGHIJK"[i], value: i});
      }
      this.selectItemOptions = arr;
    },
  },
};
</script>

<style lang="scss" scoped>
.AddQuestionModal {
  width: 100%;

  .contentWrapperPreview {
    width: 100%;
    height: 30px;
    border: solid 1px #ddd;
    overflow-y: auto;
  }
}

.titleContentWrapper {
  width: 100%;
  display: flex;

  .titleContentWrapperPreview {
    width: 100%;
    height: 120px;
    border: solid 1px #ddd;
    overflow-y: auto;
  }
}

.divMultiContentComponentOp {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: end;

  .mccoEditBtn {
    height: 48%;
    width: 80px;
  }

  .mccoEditTextBtn {
    height: 48%;
    width: 80px;
  }
}
</style>
